<div class="list-item-column">
  <div class="list-item-row-header" [ngClass]="{'opened' : opened && !shallNotOpen}">
    <div class="flex-basis-25 text-block">{{item?.alias}}</div>
    <div class="flex-basis-25 text-block text-center"></div>
    <div class="flex-basis-50 text-block text-end">{{item?.name}}</div>
  </div>
</div>
